import { render, staticRenderFns } from "./ListInitialRecommendation.vue?vue&type=template&id=60a2b184&scoped=true"
import script from "./ListInitialRecommendation.vue?vue&type=script&lang=js"
export * from "./ListInitialRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ListInitialRecommendation.vue?vue&type=style&index=0&id=60a2b184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2b184",
  null
  
)

export default component.exports